
import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { HelpService } from "../help-service";
import { Router } from "@angular/router";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/internal/operators";
import { NgSelectModule } from '@ng-select/ng-select';
import { getFormApi } from "../dataObject/GetFormApi";

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

 


  constructor(
  ) {}


 
  ngOnInit(): void {
   
  }

}
